import { takeLatest, put } from 'redux-saga/effects';
import { actions as listActions } from '../slices/TripDriverSlices';

import NetworkHandler from 'utils/network';
import config from 'config';
import NotificationHandler from 'utils/notification';

function* getListTripDriver({ payload }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_list_trip_drive')}`, {
            params: {
                ...payload,
            },
        });
        yield put({ type: listActions.get_list_succeed.type, payload: { ...response } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: listActions.get_list_failed.type, payload: error });
    }
}

function* exportTripDriverReport({ payload }) {
    console.log(payload);

    try {
        const response = yield NetworkHandler.get(`${config.getUrl('get_list_trip_drive')}`, {
            params: {
                ...payload,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
    } catch (error) {
        NotificationHandler.notifyError(error.message);
    }
}

function* watchRequestDetail() {
    yield takeLatest(listActions.get_list.type, getListTripDriver);
    yield takeLatest(listActions.export_trip_driver.type, exportTripDriverReport);
}

export default watchRequestDetail;
